// extracted by mini-css-extract-plugin
export var content = "survey-session-view-module--content--2f+63";
export var title = "survey-session-view-module--title--Jr3vP";